export const FREE_TIER_CTA = 'Keep current plan';
